export enum DRC_ASSESSMENT_MODULE {
  APPLICATION_LIST = 'Application List',
  NON_PROPOSED = 'Non-proposed Applications',
  MEET_CONDITION_CHECK = 'Meet Condition Check',
  PRIORITIZE_EVALUATION = 'Prioritise Evaluation',
  FUNCTION_HUB = 'Function Hub',
  POLISH_COMMENTS = 'Polish Comments',
  SCHOLARSHIP_MANAGEMENT = 'Scholarship Management',
}

export enum DRC_APPROVAL_MODULE {
  TO_DO_LIST = 'To-Do List',
  APPLICATION_LIST = 'Application List',
  SCHOLARSHIP_MANAGEMENT = 'Scholarship Management',
}

export enum FRC_ASSESSMENT_MODULE {
  TO_DO_LIST = 'To-Do List',
  APPLICATION_LIST = 'Application List',
  SCHOLARSHIP_MANAGEMENT = 'Scholarship Mangement',
}
export enum HOD_DOS_ASSESSMENT_MODULE {
  TO_DO_LIST = 'To-Do List',
}

export enum GS_ASSESSMENT_MODULE {
  APPLICATION_OVERVIEW = 'Application Overview',
  PANEL_MANAGEMENT = 'Panel Management',
  TO_DO_LIST = 'To-Do List',
  FAILED_LIST = 'Failed List',
  MAKE_DECISION = 'Make Decision',
  EMAIL_PROCESS = 'Email Process',
  OFFER_LIST = 'Offer List',
  DUAL_JOINT_MANAGEMENT = 'Dual Joint Management',
  SCHOLARSHIP_MANAGEMENT = 'Scholarship Management',
  FUNCTION_HUB = 'Function Hub',
  VIEW_PRIORITY = 'View Priority',
  MEET_CONDITION_CHECK = 'Meet Condition Check',
}

export enum ASSESSMENT_MODULE {
  /* DoRPgS */
  MY_ASSESSMENTS = 'My Assessments',
  APPLICATION_LIST = 'Application List',
  DORPGS_ASSESSMENT = 'DoRPgS Assessment',
  NON_PROPOSED = 'Non-proposed Applications',
  CONDITION_CHECK = 'Condition Check',
  EVALUATION = 'Scholarship Evaluation',

  /* GS */
  APPLICATION_OVERVIEW = 'Application Overview',
  PANEL_MANAGEMENT = 'Panel Management',
  TO_DO_LIST = 'To-Do List',

  PARTICULARS = 'Applicant Particulars',
  DSRC_ASSESSMENT = 'D/SRC Assessment',
  FRCSB_ASSESSMENT = 'FRC/SB Assessment',
  GS_ASSESSMENT = 'GS Assessment',

  /* HoD/DoS */
  HOD_DOS_ASSESSMENT = 'HoD/DoS Assessment',
}

export enum ASSESSMENT_DETAIL_MODULE {
  ACADEMIC_QUALIFICATION = 'ACADEMIC_QUALIFICATION',
  PUBLICATION_ASSESSMENT = 'PUBLICATION_ASSESSMENT',
  MERIT_ASSESSMENT = 'MERIT_ASSESSMENT',
  SCORE_ON_APPLICANT = 'SCORE_ON_APPLICANT',
  ADMISSION_REQUIREMENT = 'ADMISSION_REQUIREMENT',
  INTERVIEW_PANEL = 'INTERVIEW_PANEL',
  DECLARATION = 'DECLARATION',
  REFEREE_ELIGIBILITY = 'REFEREE_ELIGIBILITY',
}

export enum ASSESSMENT_DETAIL_MAP_COMPETITIVE_VER {
  ADMISSION_REQUIREMENT = 0,
  REFEREE_ELIGIBILITY,
  INTERVIEW_PANEL,
  DECLARATION,
}

export enum ASSESSMENT_DETAIL_MAP_OTHER_VER {
  ADMISSION_REQUIREMENT = 0,
  REFEREE_ELIGIBILITY,
  DECLARATION,
}
